import { addHelpAction } from './helpAction'

export const decorators = [addHelpAction]
